(exports.GAME_ID = "63b84beaa83054cc4f5af468"),
(exports.FORM_ID = "63b84beaa83054cc4f5af4ad"),
(exports.STATUS_FORM_ID = "6048f71efb14a700154b30a8"),
(exports.LINE_ITEM_ID = "62333c95ba73ec0016fc0e73"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-dev");